import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import { CircularLoader } from '@modules/common/components/CircularLoader';
import { FeedAnalysis } from '@modules/feed/components/FeedContainerIndex/FeedAnalysis';
import { useFetchSearchAnalysisAndUpdateStore } from '@modules/feed/hooks';
import { useFeedStore } from '@modules/feed/store/feedStore';
import { FeedActionType } from '@modules/feed/store/searchActionType';
import { getFeedQueryRetentionKey } from '@modules/feed/utils';
import { Box } from '@mui/material';
import { useEffect, useRef } from 'react';
import useParseSavedSlugInfo from 'v2/core/services/savedSlug/useParseSavedSlugInfo';
import { useGetUser } from 'v2/core/services/user';
import { shallow } from 'zustand/shallow';

export function SavedFeedAnalysis() {
  const {
    tenant: { slug: tenantSlug },
  } = useGetUser();

  const { token: tokenFromURL } = useParseSavedSlugInfo();

  const dispatch = useFeedStore(({ dispatch }) => dispatch);
  const { isLoading } = useFetchSearchAnalysisAndUpdateStore();
  const { analysisViewToken, analysisEditToken, resetToEmptyAnalysis } =
    useAnalysisStore(
      ({ resetToEmptyAnalysis, viewToken, editToken }) => ({
        analysisViewToken: viewToken,
        analysisEditToken: editToken,
        resetToEmptyAnalysis,
      }),
      shallow,
    );

  const dependencies = {
    analysisViewToken,
    analysisEditToken,
  };
  const dependenciesRef = useRef(dependencies);
  dependenciesRef.current = dependencies;

  useEffect(() => {
    return () => {
      resetToEmptyAnalysis();

      dispatch({
        type: FeedActionType.RESET,
      });
    };
  }, [resetToEmptyAnalysis, dispatch]);

  useEffect(() => {
    // Do early return if analysisViewToken is not present, no need to reset the analysis
    if (!dependenciesRef.current.analysisViewToken) {
      return;
    }

    if (
      dependenciesRef.current.analysisViewToken === tokenFromURL ||
      dependenciesRef.current.analysisEditToken === tokenFromURL
    ) {
      return;
    }

    dispatch({
      type: FeedActionType.RESET,
    });

    resetToEmptyAnalysis();
  }, [resetToEmptyAnalysis, tokenFromURL, dispatch]);

  useEffect(() => {
    sessionStorage.removeItem(getFeedQueryRetentionKey(tenantSlug));
  }, [tenantSlug]);

  if (isLoading) {
    return (
      <Box height="calc(100vh - 72px)">
        <CircularLoader />
      </Box>
    );
  }

  return <FeedAnalysis />;
}
